import { Component } from '@angular/core';
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import { OnInit } from '@angular/core';
import { DeezerApiService } from 'angular-deezer-api';
import { EmailService } from './email.service';
import { AdresseipService } from './adresseip.service';
import { GoogleMap } from './googlemap.config.constant';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/distinctUntilChanged';

import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'ns-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit{

  scores: FirebaseListObservable<any[]>;
  ipAddressInformations : FirebaseObjectObservable<any[]>;
  songInformations : FirebaseObjectObservable<any[]>;

  lat: number = 43.6768197;
  lng: number = 4.6275952;

  searchResult = {};
  lastProposal = [];
  selectSong = false;
  isLoading = false;
  searchDropdown = false;
  searchHasError = false;
  searchSongAlreadySend = false;
  searchSongWasSend = false;
  voteIsLoading = false;
  messageSend = false;
  proposeIsLoading = false;

  text: any = { "Weeks": "semaines",
  "Days": "jours", "Hours": "heures",
  Minutes: "minutes", "Seconds": "secondes",
  "MilliSeconds":"MilliSecondes" };

  style = GoogleMap.style;

  searchForm: FormGroup;
  contactForm: FormGroup;
  searchSongValueCtrl: FormControl;
  contactEmailValueCtrl: FormControl;
  contactMessageValueCtrl: FormControl;
  oldSearchValue;
  private ipAddress

  constructor(
    private angularFireDatabase: AngularFireDatabase,
    private deezerApiService: DeezerApiService,
    private adresseipService: AdresseipService,
    private emailService: EmailService,
    fb: FormBuilder
  ) {
    this.scores = angularFireDatabase.list('/songInformations', {
      query: {
        orderByChild: 'scoreOrder'
      }
    });
    this.ipAddressInformations = angularFireDatabase.object('/ipAddressInformations');
    this.songInformations = angularFireDatabase.object('/songInformations');

    this.searchSongValueCtrl = fb.control('', Validators.required);
    this.searchForm = fb.group({
      searchSongValue: this.searchSongValueCtrl
    })

    this.contactEmailValueCtrl = fb.control('', [Validators.required, Validators.email]);
    this.contactMessageValueCtrl = fb.control('', Validators.required);

    this.contactForm = fb.group({
      contactEmailValue: this.contactEmailValueCtrl,
      contactMessageValue: this.contactMessageValueCtrl,
    })

    this.searchSongValueCtrl.valueChanges
    .debounceTime(300)
    .distinctUntilChanged()
    .subscribe(newValue => this.getSong(newValue));
  }

  ngOnInit() {
    this.getUserIp();
  }

  getUserIp() {
    this.adresseipService.get().then(result => {
      var ip = result.ip;
      this.ipAddress = ip.split(".").join('-');
      this.getIfIpExist().then(ipExist => {
        if(!ipExist) {
          this.saveIp();
        }
      });
    });
  }

  saveIp() {
    var informations = {}
    informations[this.ipAddress] = {
      hasVotedForInformations : {},
      ipAddress : this.ipAddress
    }

    this.ipAddressInformations.update(informations)
  }

  getIfIpExist() {
    const test = this.angularFireDatabase.object(`/ipAddressInformations/${this.ipAddress}`);
    return new Promise(function(resolve, reject) {
      test.subscribe(data => {
        if(data.$exists()) {
          resolve(true)
        }
        resolve(false);
      })
    })
  }

  getSong(value) {
    if(this.oldSearchValue !== value) {
      if(value.length > 2) {
        this.deezerApiService.search(value).then(result => {
          this.searchDropdown = true;
          this.searchResult = result.data;
          this.isLoading = false;
          if(this.isEmptyObject(this.searchResult)) {
            this.searchHasError = true;
          }
        });
      } else {
        this.searchResult = {};
        this.isLoading = false;
      }
      this.oldSearchValue = value;
    }
  }

  searchSong() {
    this.getSong(this.searchForm.value.searchSongValue);
  }

  submitThisSong(data) {
    this.proposeIsLoading = true;

    this.getIfSongExist(data.id).then(songExist => {
      if(!songExist) {

        var informations = {}
        informations[data.id] = {
          artist : data.artist.name,
          id : data.id,
          link : data.link,
          score : 1,
          scoreOrder : -1,
          sendBy: this.ipAddress,
          title: data.title
        }

        informations[data.id]['whoVoted'] = {};
        informations[data.id]['whoVoted'][this.ipAddress] = this.ipAddress;

        var promise2 = this.songInformations.update(informations);

        var obj = {};
        obj[data.id] = {
          id: data.id,
          value: 1
        }
        const ipAddressInformationsHasVotedForInformations = this.angularFireDatabase.object(`/ipAddressInformations/${this.ipAddress}/hasVotedForInformations`);
        var promise4 = ipAddressInformationsHasVotedForInformations.update(obj);

        if(this.selectSong) {
          this.selectSong = false;
        }
        this.searchSongValueCtrl.setValue('');
        this.searchSongWasSend = true;

        Promise.all([promise2, promise4]).then(values => {
          this.proposeIsLoading = false;
        })


      } else {
        this.searchSongAlreadySend = true;
        this.proposeIsLoading = false;
      }


    });

  }

  getIfSongExist(id) {
    const test = this.angularFireDatabase.object(`/songInformations/${id}`);
    return new Promise(function(resolve, reject) {
      test.subscribe(data => {
        if(data.$exists()) {
          resolve(true)
        }
        resolve(false);
      });
    });
  }

  getLastProposal() {
    this.lastProposal = [];

    this.songInformations.subscribe(snapshots => {
      for(let index in snapshots) {
        var element = snapshots[index];
        var whoVotedArray = element.whoVoted;
        var hasVoted = false;
        for(let index in whoVotedArray) {
          var whoVoted = whoVotedArray[index];
          if(whoVoted === this.ipAddress) {
            hasVoted = true;
          }
        }
        if(!hasVoted) {
          this.lastProposal.push(element);
        }
      }
    });

    if(this.lastProposal.length > 0) {
      return true;
    }
    return false;
  }

  upScore(song) {
    this.voteIsLoading = true;
    const songInformationsId = this.angularFireDatabase.object(`songInformations/${song.id}`);
    var newScore = parseInt(song.score) + 1;
    var newScoreOrder = parseInt(song.scoreOrder) - 1;
    let p1 = songInformationsId.update({score: newScore, scoreOrder: newScoreOrder});
    const songInformationsIdWhoVoted = this.angularFireDatabase.object(`songInformations/${song.id}/whoVoted`);
    var obj = {};
    obj[this.ipAddress] = this.ipAddress;
    let p2 = songInformationsIdWhoVoted.update(obj);
    var obj = {};
    obj[this.ipAddress] = this.ipAddress;
    let p3 = songInformationsIdWhoVoted.update(obj);
    var obj = {};
    obj[song.id] = {
      id: song.id,
      value: 1
    }
    const ipAddressInformationsHasVotedForInformations = this.angularFireDatabase.object(`/ipAddressInformations/${this.ipAddress}/hasVotedForInformations`);
    let p5 = ipAddressInformationsHasVotedForInformations.update(obj);

    Promise.all([p1, p2, p3]).then(values => {
      this.voteIsLoading = false;
    })


  }

  passSong(song) {
    this.voteIsLoading = true;
    const songInformationsIdWhoVoted = this.angularFireDatabase.object(`songInformations/${song.id}/whoVoted`);
    var obj = {};
    obj[this.ipAddress] = this.ipAddress;
    let p1 = songInformationsIdWhoVoted.update(obj);
    var obj = {};
    obj[song.id] = {
      id: song.id,
      value: 0
    }
    const ipAddressInformationsHasVotedForInformations = this.angularFireDatabase.object(`/ipAddressInformations/${this.ipAddress}/hasVotedForInformations`);
    let p3 = ipAddressInformationsHasVotedForInformations.update(obj);

    Promise.all([p1, p3]).then(values => {
      this.voteIsLoading = false;
    })

  }

  selectThisSong(song) {
    this.selectSong = song;
    var titre = `${song.title} - ${song.artist.name}`;
    this.searchSongValueCtrl.setValue(titre);
    this.oldSearchValue = titre;
    this.searchResult = {};
    this.searchDropdown = false;
  }

  isSearching() {

    if(this.selectSong) {
      this.selectSong = false;
    }
    if(!this.isLoading) {
      this.isLoading = true;
    }

    if(this.searchDropdown) {
      this.searchDropdown = false;
    }

    if(this.searchHasError) {
      this.searchHasError = false;
    }

    if(this.searchSongAlreadySend) {
      this.searchSongAlreadySend = false;
    }

    if(this.searchSongWasSend) {
      this.searchSongWasSend = false;
    }

  }

  closeSearchDropDown(event) {
    var target = event.target;
    if(!target.closest(".playlist-form")) {
      this.searchDropdown = false;
    }
  }

  searchIsFocus() {
    if(!this.isEmptyObject(this.searchResult)) {
      this.searchDropdown = true;
    }
  }

  isEmptyObject(obj) {
    return (obj && (Object.keys(obj).length === 0));
  }

  sendMessage() {

    var data = {
      data: {
        message: this.contactMessageValueCtrl.value
      },
      dataType: "json"
    };

    this.emailService.send(data).then(result => {
      if(result.success) {
        this.messageSend = true;
        this.contactForm.reset();

        setTimeout(data => {
          this.messageSend = false;
        }, 10000);
      }
    });

  }

  voteIsLoadingFn() {
    return this.voteIsLoading;
  }

  proposeIsLoadingFn() {
    return this.proposeIsLoading;
  }

  isLoadingFn() {
    return this.isLoading;
  }

  hasVoted(song) {
      return (song.whoVoted[this.ipAddress]) ? true: false;
  }

}



// WEBPACK FOOTER //
// /Users/mac-jeremy/Projets/fairepart/src/app/home/home.component.ts